<template>
  <div>
    <!--    <v-tooltip bottom>-->
    <!--      <template v-slot:activator="{ on, attrs }">-->
    <!--        <v-btn-->
    <!--          fab-->
    <!--          small-->
    <!--          dark-->
    <!--          v-bind="attrs"-->
    <!--          v-on="on"-->
    <!--          bottom-->
    <!--          right-->
    <!--          class="float-right mx-4"-->
    <!--          color="success"-->
    <!--          style="position: relative; margin-top: -60px"-->
    <!--          @click="addProduct"-->
    <!--        >-->
    <!--          <v-icon>mdi-plus</v-icon>-->
    <!--        </v-btn>-->
    <!--      </template>-->
    <!--      <span>Adicionar Categoria de Produto</span>-->
    <!--    </v-tooltip>-->
    <v-card elevation="0">
      <v-row v-for="cat in getCategoryInCache" :key="cat">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="6"
          lg="3"
          v-for="product in cat.productCategoryEntits"
          :key="product"
        >
          <v-card
            class="mx-2"
            style="box-shadow: 0 4px 1px -3px #0000000d, 0 0 0 0 #00000000, 0 1px 5px 0 #00000008; background-color: #f6f6f6"
          >
            <div>
              <v-row>
                <v-col class="mx-4">
                  <div class="text-uppercase text-card-title">
                    {{ product.productsCategory.productCategoryName }}
                  </div>
                  <div class="blue-grey--text" style="font-size: 12px">
                    {{ product.productsCategory.products.length }} {{product.productsCategory.products.length > 1 ? 'Produtos' : 'Produto'}}
                  </div>
<!--                  <div class="text-card-category">-->
<!--                    <v-icon size="12">mdi-view-list</v-icon-->
<!--                    >{{ product }}-->
<!--                  </div>-->
                </v-col>
                <v-col class="mx-3 bg-card-sugest text-right">
                  <div>
                    <span>
                      <v-btn
                        fab
                        dark
                        text
                        small
                        color="success"
                        class="mx-2"
                        @click="
                          appendProductInCategory(product.productCategoryID)
                        "
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </span>
                    <span>
                      <v-btn
                        fab
                        dark
                        text
                        small
                        color="indigo"
                        class="mx-2"
                        @click="
                          viewProducts(
                            product.productsCategory.productCategoryUUID
                          )
                        "
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </span>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import eventBus from "../../../../main";
import { mapHelperEnterprise } from "../../../../store/helperEnterprise";

export default {
  name: "ProductCategoryCompany",
  data: () => ({}),
  methods: {
    edit() {
      eventBus.$emit("openEditProduct", true);
    },
    viewProducts(index) {
      // eventBus.$emit("openDeleteProduct", true);
      this.$router.push("/products/view/" + index);
    },
    appendProductInCategory(index) {
      //alert(index)
      const value = {
        dialog: true,
        index: index
      };
      eventBus.$emit("OpenAppendProductToCategory", value);
    }
    // addProduct() {
    //   eventBus.$emit("openAddProductCategory", true);
    // }
  },
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped>
.text-card-title {
  color: #8898aa !important;
  font-size: 12px;
}
.text-card-category {
  /*color: #560707 !important;*/
  color: #35775b !important;
  font-size: 11px;
  /*background: linear-gradient(87deg, #fb6340, #fbb140) !important;*/
}
.bg-card-sugest {
  background: linear-gradient(87deg, #9c2a2a00, #26a69a24) !important;
  /*background: linear-gradient(87deg, #9c2a2a00, #1976d259) !important;*/
  /*background: linear-gradient(87deg, #9c2a2a00, #8dfb4078) !important;*/
}
</style>
